import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ChildLink } from 'config/types';
import { classNames } from 'shared/utils';
import { DownOutlined, UpOutlined } from '@ant-design/icons/lib';
import styles from 'pages/section/section.module.scss';

type Props = { child: ChildLink}

export const ListItem = ({ child }: Props) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  const tree = (children: ChildLink[]) => (
	<ul className={styles.list}>
	  {children.map((child, idx) => (
		<ListItem child={child} key={idx}/>
	  ))}
	</ul>
  );
  
  const toggleItem = (event: any) => {
	event.stopPropagation();
	setExpanded(!expanded);
  };
  
  if (!child.childrenLinks.length) {
    return (
	  <li className={styles.listItem}>
		<NavLink className={styles.link} to={child.url}>{child.name}</NavLink>
	  </li>
	);
  }
  
  
  return (
	<li className={styles.listItem}>
	  <div className={styles.listItemTitle}>
		<div className={styles.listItemToggle} onClick={(e) => toggleItem(e)}>
		  {expanded
			? <UpOutlined style={{ fontSize: '16px', color: '#737781' }}/>
			: <DownOutlined style={{ fontSize: '16px', color: '#737781' }}/>
		  }
		</div>
		<NavLink className={styles.linkWithTitle} to={child.url}>{child.name}</NavLink>
	  </div>
	  <div className={classNames(styles.listWrapper, expanded && styles.isExpanded)}>
		{ tree(child.childrenLinks) }
	  </div>
	</li>
  );
};
